<template>
    <div>
        <app-breadcrumb :items="breadcrumbItens"></app-breadcrumb>
        <b-card no-body>
            <b-card-header>
                <span class="h5">DETALHAR SERVIÇO</span>
                <div class="float-right">
                    <b-button 
                        variant="secondary" 
                        size="sm" 
                        @click="voltar()"
                    >
                        <i class="fa fa-arrow-left"></i> Voltar
                    </b-button>
                </div>
            </b-card-header>
            <b-card-body>
                <div v-if="comprometimento">
                    <comprometimento-dados
                        :comprometimento="comprometimento"
                    ></comprometimento-dados>
                    <comprometimento-documentacao
                        class="mt-4"
                        v-model="comprovacoes"
                        :comprometimento="comprometimento"
                        v-if="comprometimento.contratoTipoEspecial"
                        :naoPermiteEditar="true"
                    ></comprometimento-documentacao>
                    <comprometimento-pesquisa
                        class="mt-2"
                        v-model="avaliacoes"
                        :comprometimento="comprometimento"
                        :naoPermiteEditar="true"
                    >
                    </comprometimento-pesquisa>
                </div>
                <div v-else>
                    <p>Carregando dados do serviço...</p>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import ComprometimentoDocumentacao from '../../gescon/aprovadores/ComprometimentoDocumentacao'
import ComprometimentoPesquisa from '../../gescon/aprovadores/ComprometimentoPesquisa'
import ComprometimentoDados from '../../gescon/aprovadores/ComprometimentoDados'
import { comprometimentoStatus } from '../../gescon/comprometimentos/ComprometimentoStatus'
import ServicosServicos from './ServicosServicos'

export default {
    name: 'FornecedorServicoDetalhar',
    components: {
        ComprometimentoDocumentacao,
        ComprometimentoPesquisa,
        ComprometimentoDados
    },

    computed: {
        comprometimentoId() {
            return parseInt(this.$route.params.comprometimentoId)
        },

        breadcrumbItens() {
            return [
                { text: 'GESCON' },
                { text: 'Fornecedor' },
                { text: 'Serviços', to: { name: 'Fornecedor_Contratos_Servicos_Listagem' } },
                { text: 'Detalhar', active: true }
            ]
        }
    },

    data() {
        return {
            comprometimento: null,
            comprovacoes: null,
            avaliacoes: null,
            carregando: false
        }
    },

    mounted() {
        this.carregarComprometimento()
    },

    methods: {
        async carregarComprometimento() {
            this.carregando = true
            try {
                const response = await ServicosServicos.obterComprometimentoPorId(this.comprometimentoId)
                if (response && response.success) {
                    this.comprometimento = response.data
                    this.comprovacoes = {
                        comprovacao01: this.comprometimento.comprovacao01,
                        comprovacao02: this.comprometimento.comprovacao02
                    }
                    this.avaliacoes = { avaliacoes: this.comprometimento.avaliacoes }
                } else {
                    this.$toast.error('Erro ao carregar dados do serviço')
                }
            } catch (error) {
                console.error('Erro ao carregar comprometimento:', error)
                this.$toast.error('Erro ao carregar dados do serviço')
            } finally {
                this.carregando = false
            }
        },

        voltar() {
            this.$router.push({ name: 'Fornecedor_Contratos_Servicos_Listagem' })
        }
    }
}
</script>